import axios from 'axios'
import { message } from 'ant-design-vue'

// 创建 axios 实例
const service = axios.create({
  baseURL: 'https://poollineradmin.landy360.com/api', // API 的基础URL
  timeout: 15000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果返回的状态码不是1，说明接口请求有误
    if (res.code !== 1) {
      message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误：', error)
    message.error(error.message || '请求失败')
    return Promise.reject(error)
  }
)

export default service
